// import * as React from "react";

// const Subscription = ({ color = "#FFFFFF", size = 20, ...props }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     width={size}
//     height={size}
//     fill={color}
//     {...props}
//   >
//     <path d="M12 4h-3v-1h3zm2 3h6v-1h-6zm6-4h-6v1h6zm-5 9.568c0-1.274-.896-2.38-2.083-2.572-1.483-.278-2.95.962-2.917 2.466v7.601l-1.826-1.454-.002.002c-1.008-.912-2.568-.854-3.498.143-.941 1.007-.894 2.588.106 3.524l1.841 1.722h1.44l-2.593-2.446c-.599-.562-.629-1.514-.064-2.118.562-.603 1.509-.635 2.115-.072.011.01 3.479 2.773 3.479 2.773v-9.675c-.019-.905.862-1.651 1.756-1.479.709.115 1.244.797 1.244 1.586v5.24l8 3v3.191h1v-3.885l-8-3v-4.547zm-6-5.568h3v-1h-3zm-2-1h-3v1h3zm-3 4h2v-1h-2zm16 0v-1h-2v1zm-13-7h-3v1h3zm14.5-3h-19c-1.378 0-2.5 1.121-2.5 2.5v10.5h8v-1h-7v-9.5c0-.827.673-1.5 1.5-1.5h19c.827 0 1.5.673 1.5 1.5v9.5h-6v1h7v-10.5c0-1.379-1.121-2.5-2.5-2.5z" />
//   </svg>
// );

// export default Subscription;
import React from 'react'

const Subscription = ({ size = 20, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={18}
    fill={color}
  >
    <path d="M11.026,12H4v-1H12.028c-.362,.305-.696,.64-1.003,1Zm-7.026,4h5.14c.061-.34,.135-.675,.235-1H4v1Zm20,1.5c0,3.584-2.916,6.5-6.5,6.5s-6.5-2.916-6.5-6.5,2.916-6.5,6.5-6.5,6.5,2.916,6.5,6.5Zm-1,0c0-3.033-2.468-5.5-5.5-5.5s-5.5,2.467-5.5,5.5,2.468,5.5,5.5,5.5,5.5-2.467,5.5-5.5Zm-6.02,1.452c-.082,.082-.144,.091-.241-.006l-1.856-1.799-.695,.718,1.851,1.793c.22,.221,.513,.342,.824,.342s.605-.122,.822-.339l3.456-3.399-.701-.713-3.459,3.402Zm-1.98-11.952H4v1H15v-1ZM2.5,23c-.827,0-1.5-.673-1.5-1.5V3H18v6.032c.339,.022,.673,.062,1,.122V2h-3V0h-1V2h-3V0h-1V2h-3V0h-1V2h-3V0h-1V2H0V21.5c0,1.378,1.121,2.5,2.5,2.5H12.028c-.36-.303-.689-.641-.992-1H2.5Z" />
  </svg>
)

export default Subscription
